import { c as _c } from "react-compiler-runtime";
import { useContext } from 'react';
import FormattedNumber from './FormattedNumber';
import NumberTypes from '../constants/NumberTypes';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedPercentage(props) {
  const $ = _c(2);
  useContext(I18nHMRContext);
  let t0;
  if ($[0] !== props) {
    t0 = /*#__PURE__*/_jsx(FormattedNumber, Object.assign({
      style: NumberTypes.PERCENTAGE
    }, props));
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
FormattedPercentage.displayName = 'FormattedPercentage';
export default FormattedPercentage;